import { ProjectSectionFilter, ProjectSectionSort } from '../core/domain/Project';
import { ExternalProjectConfigurationPort } from '../core/project/ExternalProjectConfigurationPort';

const PROJECT_PREFIX = 'project';
export class ExternalProjectConfigurationProvider implements ExternalProjectConfigurationPort {
    private readonly sortKey = `${PROJECT_PREFIX}-sort`;
    private readonly filterKey = `${PROJECT_PREFIX}-filter`;
    saveProjectSectionsSort(sort: ProjectSectionSort): void {
        localStorage.setItem(this.sortKey, JSON.stringify(sort));
    }
    loadProjectSectionsSort(): ProjectSectionSort {
        const storedSort = localStorage.getItem(this.sortKey);

        return storedSort ? JSON.parse(storedSort) : [];
    }
    saveProjectSectionsFilter(filter: ProjectSectionFilter): void {
        localStorage.setItem(this.filterKey, JSON.stringify(filter));
    }
    loadProjectSectionsFilter(): ProjectSectionFilter {
        const storedFilter = localStorage.getItem(this.filterKey);

        return storedFilter ? JSON.parse(storedFilter) : { items: [] };
    }
    saveProjectSectionId(projectSectionId: string): void {
        localStorage.setItem(`${PROJECT_PREFIX}-project-section-id`, projectSectionId);
    }
    loadProjectSectionId(): string | null {
        const projectSectionId = localStorage.getItem(`${PROJECT_PREFIX}-project-section-id`);

        return projectSectionId ?? null;
    }

    saveColumnVisibility(userId: string, model: Record<string, boolean>): void {
        localStorage.setItem(`${PROJECT_PREFIX}-columns-${userId}`, JSON.stringify(model));
    }

    loadColumnVisibility(userId: string): Record<string, boolean> {
        const stored = localStorage.getItem(`${PROJECT_PREFIX}-columns-${userId}`);

        return stored ? JSON.parse(stored) : {};
    }
}
